
<template lang="html">
    <!--<v-container style="padding-top: 100px;">-->
    <div class="container-fluid">

        <v-row>
            <v-col lg=12 cols=12 style="margin: 0 auto;">
                <v-flex xs12 sm12 md12>
                    <v-card flat class="text-xs-center ma-8" width="100%">
                        <v-card-title class="pa-5 pb-3 primary">
                            <v-toolbar-title id="titulocard">Deméritos</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>

                        <v-card-text class="pa-1 pt-4">
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-col cols="auto"
                                       lg="3">
                                    <v-text-field v-model="search"
                                                  append-icon="mdi-magnify"
                                                  label="Search"
                                                  single-line
                                                  hide-details></v-text-field>
                                </v-col>
                            </v-card-title>
                            <v-data-table :headers="headers"
                                          :items="documentos"
                                          no-data-text="No hay datos disponibles"
                                          :search="search"
                                          :items-per-page="20"
                                          :loading="show"
                                          loading-text="Loading... Please wait"
                                          class="elevation-1"
                                          :style="{float: 'none', margin: '0 auto', width: '100%'}"
                                          :footer-props="{
                      'items-per-page-options': [20, 50, 100],
                      'items-per-page-text':'Registros por página'
                    }">


                            </v-data-table>





                        </v-card-text>

                    </v-card>
                </v-flex>
            </v-col>
        </v-row>
    </div>

    <!--</v-container>-->

</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import seguimiento from '@/services/Seguimiento/seguimiento.service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    export default {
        data() {
            return {
                nrreporte: '',
                svindice: '',
                aiclave: '',
                search: '',
                documentos: [],
                show: true,
                headers: [
                    { text: 'Documentos', value: 'Documento', class: "text title"  },
                    { text: 'Monto', value: 'Monto', class: "text title"  },
                    { text: 'Fecha', value: 'Fecha', class: "text title"  },
                    { text: 'Usuario', value: 'uslogin', class: "text title"  }
                ],
            }
        },
        computed: {
            ...mapGetters(['getUser', 'THEME_STATE']),
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage', 'permission']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        async mounted() {

            let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.nrreporte = datos.nrreporte;
            this.svindice = datos.svindice;
            this.aiclave = datos.aiclave;

            await seguimiento.obtenerdemeritos(this).then(response => {
                this.documentos = response;
                this.show = false;

            });

        }
    }
</script>

